import React, { useEffect, useRef, useState } from 'react';
import { IconButton} from '@coolremote/shared';
import { EditIcon } from 'src/logos';

import useStyles from './styles';
import { Check } from '@material-ui/icons';

const EditInPlaceCell = ({ value, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);
  const [isHovered, setIsHovered] = useState(false);

  const classes = useStyles();

  const handleSaveClick = () => {
    onSave(editValue);
    // Delay the state update action to allow button animation to complete.
    setTimeout(() => {
      setIsEditing(false);
    }, 200);
  };


  const handleEditClick = (e) => {
    e.stopPropagation();
    // Delay the state update action to allow button animation to complete.
    setTimeout(() => {
      setIsEditing(true);
    }, 200);
  };

  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const blurTimeout = useRef(null);

  useEffect(() => {
    if (!isEditing || !inputRef.current) return;

    const handleBlur = () => {
      if (blurTimeout.current) clearTimeout(blurTimeout.current);
      // Delay cancel so save click (which uses a 200ms timeout) can complete first
      blurTimeout.current = setTimeout(() => {
        setIsEditing(false);
        setEditValue(value);
      }, 250);
    };

    const el = inputRef.current;
    el.addEventListener('blur', handleBlur);

    return () => {
      el.removeEventListener('blur', handleBlur);
      if (blurTimeout.current) clearTimeout(blurTimeout.current);
    };
  }, [isEditing, value]);

  useEffect(() => {
    if (!isEditing) setEditValue(value);
  }, [value, isEditing]);


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSaveClick();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
      setEditValue(value);
    }
  };


  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isEditing ? (
        <div className={classes.wrapper}>
          <input
            ref={inputRef}
            className={classes.input}
            type="text"
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <IconButton onClick={handleSaveClick}>
            <Check />
          </IconButton>
        </div>
      ) : (
        <div className={classes.wrapper}>
          {value}
          {isHovered && (
            <IconButton onClick={handleEditClick}>
              <EditIcon />
            </IconButton>
          )}
        </div>
      )}
    </div>
  );
};

export default EditInPlaceCell;
